<template>
  <layout title="Delivery Methods">
    <add-delivery-method slot="add" v-if="hasEdit('delivery-methods')" />
    <static-table-view :list="list" :headers="headers">
      <template v-slot:item.color="{ value }">
        <span class="status-dot" :style="{ background: value }"></span>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <add-delivery-method
            v-if="hasEdit('delivery-methods')"
            :item="item"
          />
          <delete-icon-button
            v-if="hasDelete('delivery-methods')"
            @click="remove(item)"
          />
        </div>
      </template>
    </static-table-view>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import StaticTableView from "@/components/ui/StaticTableView.vue";
import {colDeliveryMethods, colFaxes} from "@/assets/utils/firebase.utils";
import {deleteDoc, doc, getDocs, limit, query, where,} from "firebase/firestore";
import DeleteIconButton from "@/components/ui/buttons/DeleteIconButton.vue";
import AddDeliveryMethod from "@/components/mycompany/AddDeliveryMethod.vue";

export default {
  components: {
    Layout,
    StaticTableView,
    DeleteIconButton,
    AddDeliveryMethod,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: "Name", value: "name" },
        { text: "Action", value: "action", width: "100px" },
      ];
    },
    list() {
      return this.$store.getters.deliveryMethods;
    },
  },
  methods: {
    async remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this Delivery Method?",
        onConfirm: () => {
          // eslint-disable-next-line no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            try {
              let q = query(colFaxes, where("status", "==", id), limit(1));
              let docs = (await getDocs(q)).docs;
              if (docs.length > 0) {
                reject({
                  message:
                    "This Delivery Method cannot be deleted since it's assigned to the dispute letters.",
                });
                return;
              }
              await deleteDoc(doc(colDeliveryMethods, id));
              vm.notifySuccess(
                "Delivery Method has been deleted successfully."
              );
              resolve();
            } catch (error) {
              reject(error);
            }
          });
        },
      });
    },
  },
  mounted() {},
};
</script>

<style>
.status-dot {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: inline-block;
}
</style>
